/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_TitleInputs */



/**
* | output |
* | --- |
* | "Extract Subtitles" |
*
* @param {Subtitle_Extract_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_title = /** @type {((inputs?: Subtitle_Extract_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraire les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel extrahieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrai i sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечь субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extraer subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提取字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕を抽出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक निकालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extrair legendas")
	return /** @type {LocalizedString} */ ("Extract Subtitles")
});